var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewLayer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52,28.565a1.523,1.523,0,0,0-.7-1.281l-6.8-4.372,6.8-4.372a1.524,1.524,0,0,0,0-2.563L26.824.242a1.524,1.524,0,0,0-1.648,0L.7,15.978a1.523,1.523,0,0,0,0,2.563L7.484,22.9.7,27.285a1.523,1.523,0,0,0,0,2.561L25.177,45.581a1.523,1.523,0,0,0,1.648,0l3.982-2.56A10.664,10.664,0,1,0,47.237,32.459L51.3,29.847a1.524,1.524,0,0,0,.7-1.281ZM26,3.335,47.66,17.259,26,31.183,4.341,17.259Zm22.953,38a7.617,7.617,0,1,1-7.617-7.617A7.626,7.626,0,0,1,48.953,41.337ZM43.9,30.984a10.667,10.667,0,0,0-13.042,8.384L26,42.489,4.336,28.562,10.3,24.711l14.878,9.564a1.523,1.523,0,0,0,1.648,0l14.859-9.553,5.976,3.842Zm0,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.617,365.047h-1.523v-1.523a1.523,1.523,0,0,0-3.047,0v1.523h-1.523a1.523,1.523,0,0,0,0,3.047h1.523v1.523a1.523,1.523,0,0,0,3.047,0v-1.523h1.523a1.523,1.523,0,0,0,0-3.047Zm0,0",
    transform: "translate(-325.234 -325.234)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLayer);
export default __webpack_public_path__ + "static/media/new-layer.ce2c1ce03c6703cd18e5e44be2358ecc.svg";
export { ForwardRef as ReactComponent };